(function (app, ng) {

    app.controller("editEventController", editEventController);
    editEventController.$inject = ["$mdDialog", "$q", "eventGroupApi", "ancillaryEventGroupApi", "$timeout", "_formPattern", "_", "moment"];
    function editEventController($mdDialog, $q, eventGroupApi, ancillaryEventGroupApi, $timeout, formPattern, _, moment) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    saving: false
                },
                stats: {},
                close: close,
                deleteEvent: deleteEvent,
                update: update,
                calcStats: calcStats,
                hasSaved: false,
                showSavedMessage: showSavedMessage,
                formPattern: formPattern
            });

        function close($event) {
            if (!ng.equals($ctrl.eventGroup, $ctrl.eventGroupCopy) || !ng.equals($ctrl.event, $ctrl.eventCopy)) {

                var confirm = $mdDialog.confirm({
                    title: "Are you sure you want to close without saving?",
                    targetEvent: $event,
                    ariaLabel: "Confirm event save",
                    ok: "Yes",
                    cancel: "No",
                    skipHide: true,
                    multiple: true,
                    onComplete: function() {
                        var $dialog = ng.element(document.querySelector("md-dialog"));
                        var $actionsSection = $dialog.find("md-dialog-actions");
                        var $cancelButton = $actionsSection.children()[0];
                        $cancelButton.focus();
                    }
                });

                $mdDialog.show(confirm).then(function () {
                    $mdDialog.hide({
                        eventGroup: $ctrl.eventGroup,
                        event: $ctrl.event,
                        unsaved: true
                    });
                });
            } else {
                $mdDialog.hide({
                    eventGroup: $ctrl.eventGroupCopy,
                    event: $ctrl.eventCopy
                });
            }
        }

        function deleteEvent($event) {
            var confirm = $mdDialog.confirm({
                theme: "confirmDelete",
                title: "Are you sure you want to delete this event?",
                targetEvent: $event,
                ariaLabel: "Confirm event removal",
                ok: "Delete",
                cancel: "Cancel",
                skipHide: true,
                multiple: true,
                onComplete: function() {
                    var $dialog = ng.element(document.querySelector("md-dialog"));
                    var $actionsSection = $dialog.find("md-dialog-actions");
                    var $cancelButton = $actionsSection.children()[0];
                    $cancelButton.focus();
                }
            });

            $mdDialog.show(confirm).then(function () {
                $ctrl.ui.deleting = true;
                if (!$ctrl.eventGroup.EventType.IsAncillary) {
                    return eventGroupApi.deleteEvent($ctrl.eventGroup.Id, $ctrl.event.Id).then(function () {
                        $ctrl.ui.deleting = false;
                        return $mdDialog.hide({
                            eventGroupId: $ctrl.eventGroup.Id,
                            eventId: $ctrl.event.Id,
                            toDelete: true
                        });
                    });
                }
                return ancillaryEventGroupApi.deleteAncillaryEvent($ctrl.eventGroup.Id, $ctrl.event.Id)
                    .then(function () {
                        $ctrl.ui.deleting = false;
                        return $mdDialog.hide({
                            eventGroupId: $ctrl.eventGroup.Id,
                            eventId: $ctrl.event.Id,
                            toDelete: true
                        });
                    });
            });
        }

        function showSavedMessage() {
            $ctrl.hasSaved = true;
            $timeout(function () {
                $ctrl.hasSaved = false;
            }, 3000);
        }

        function update() {
            $ctrl.ui.saving = true;
            $ctrl.event.EventDate = new Date($ctrl.ui.eventDate);

            if (!$ctrl.eventGroup.EventType.IsAncillary) {
                eventGroupApi.update($ctrl.eventGroup.Id, $ctrl.eventGroup).then(function () {
                    var promises = [];

                    if (!!$ctrl.eventGroup.Reservations)
                        promises.push(eventGroupApi.updateReservations($ctrl.eventGroup.Id, $ctrl.eventGroup));

                    if (!!$ctrl.eventGroup.Attendees)
                        promises.push(eventGroupApi.updateAttendees($ctrl.eventGroup.Id, $ctrl.eventGroup));

                    if (!!$ctrl.eventGroup.UnitsAttended)
                        promises.push(eventGroupApi.updateUnitsAttended($ctrl.eventGroup.Id, $ctrl.eventGroup));

                    if (!!$ctrl.eventGroup.AppointmentsSet)
                        promises.push(eventGroupApi.updateAppointmentsSet($ctrl.eventGroup.Id, $ctrl.eventGroup));

                    if (!!$ctrl.eventGroup.AppointmentsKept)
                        promises.push(eventGroupApi.updateAppointmentsKept($ctrl.eventGroup.Id, $ctrl.eventGroup));

                    if (!!$ctrl.eventGroup.AppointmentsClosed)
                        promises.push(eventGroupApi.updateAppointmentsClosed($ctrl.eventGroup.Id, $ctrl.eventGroup));

                    $q.all(promises).then(function () {
                        eventGroupApi.updateEvent($ctrl.eventGroup.Id, $ctrl.event.Id, $ctrl.event).then(function () {
                            $ctrl.ui.saving = false;                           
                            showSavedMessage();

                            $ctrl.eventCopy = ng.copy($ctrl.event);
                            $ctrl.eventGroupCopy = ng.copy($ctrl.eventGroup);
                        });
                    });
                });
            } else {
                ancillaryEventGroupApi.update($ctrl.eventGroup.Id, $ctrl.eventGroup).then(function () {
                    ancillaryEventGroupApi.updateAncillaryEvent($ctrl.eventGroup.Id, $ctrl.event.Id, $ctrl.event).then(function () {
                        $ctrl.ui.saving = false;                      
                        showSavedMessage();

                        $ctrl.eventCopy = ng.copy($ctrl.event);
                        $ctrl.eventGroupCopy = ng.copy($ctrl.eventGroup);
                    });
                });
            }
        }

        function calcStats() {
            var clientEventTypes = [
                "Client Appreciation Events", "Client Educational Events",
                "Social Events", "Holiday Events", "Referral Events"
            ];

            $ctrl.stats = {
                responseRate: 0,
                noShowRate: 0,
                appointmentSettingRate: 0,
                persistencyRate: 0,
                closeRate: 0,
                roi: 0
            };

            var totalReservations = $ctrl.eventGroup.Reservations ? (($ctrl.eventGroup.Reservations.Prospects || 0) +
                ($ctrl.eventGroup.Reservations.Referrals || 0) +
                ($ctrl.eventGroup.Reservations.Clients || 0)) : 0;
            var totalAttendees = $ctrl.eventGroup.Attendees ? (($ctrl.eventGroup.Attendees.Prospects || 0) +
                ($ctrl.eventGroup.Attendees.Referrals || 0) +
                ($ctrl.eventGroup.Attendees.Clients || 0)) : 0;
            var totalUnitsAttended = $ctrl.eventGroup.UnitsAttended ? (($ctrl.eventGroup.UnitsAttended.Prospects || 0) +
                ($ctrl.eventGroup.UnitsAttended.Referrals || 0) +
                ($ctrl.eventGroup.UnitsAttended.Clients || 0)) : 0;
            var totalAppointmentsSet = $ctrl.eventGroup.AppointmentsSet ? (($ctrl.eventGroup.AppointmentsSet.Prospects || 0) +
                ($ctrl.eventGroup.AppointmentsSet.Referrals || 0) +
                ($ctrl.eventGroup.AppointmentsSet.Clients || 0)) : 0;
            var totalAppointmentsKept = $ctrl.eventGroup.AppointmentsKept ? (($ctrl.eventGroup.AppointmentsKept.Prospects || 0) +
                ($ctrl.eventGroup.AppointmentsKept.Referrals || 0) +
                ($ctrl.eventGroup.AppointmentsKept.Clients || 0)) : 0;
            var totalAppointmentsClosed = $ctrl.eventGroup.AppointmentsClosed ? (($ctrl.eventGroup.AppointmentsClosed.Prospects || 0) +
                ($ctrl.eventGroup.AppointmentsClosed.Referrals || 0) +
                ($ctrl.eventGroup.AppointmentsClosed.Clients || 0)) : 0;

            if ($ctrl.eventGroup.Reservations && $ctrl.eventGroup.Invites > 0) {
                if (_.find(clientEventTypes, function (row) { return row === $ctrl.eventGroup.EventType.Name; })) {
                    $ctrl.stats.responseRate = totalReservations / $ctrl.eventGroup.Invites;
                } else {
                    $ctrl.stats.responseRate = $ctrl.eventGroup.Reservations.Prospects / $ctrl.eventGroup.Invites;
                }
            }
            if ($ctrl.eventGroup.Reservations && $ctrl.eventGroup.Attendees && totalReservations > 0) {
                $ctrl.stats.noShowRate = (totalReservations - totalAttendees) / totalReservations;
            }
            if ($ctrl.eventGroup.UnitsAttended && $ctrl.eventGroup.AppointmentsSet && totalUnitsAttended > 0) {
                $ctrl.stats.appointmentSettingRate = totalAppointmentsSet / totalUnitsAttended;
            }
            if ($ctrl.eventGroup.AppointmentsKept && $ctrl.eventGroup.AppointmentsSet && totalAppointmentsSet > 0) {
                $ctrl.stats.persistencyRate = totalAppointmentsKept / totalAppointmentsSet;
            }
            if ($ctrl.eventGroup.AppointmentsClosed && $ctrl.eventGroup.AppointmentsKept && totalAppointmentsKept > 0) {
                $ctrl.stats.closeRate = totalAppointmentsClosed / totalAppointmentsKept;
            }
            if ($ctrl.eventGroup.TotalEventCost > 0) {
                $ctrl.stats.roi = (($ctrl.eventGroup.TotalCommission || 0) - $ctrl.eventGroup.TotalEventCost) /
                    $ctrl.eventGroup.TotalEventCost;
            }
        }

        $ctrl.$onInit = () => {
            $ctrl.ui.eventDate = moment($ctrl.event.EventDate).format("L");

            //Do we need to change to UTC?  I'm not seeing a difference if we do on the calendar/date display'
            //$ctrl.event.EventDate = convertDateToUtc($ctrl.event.EventDate);
            
            //$ctrl.event.EventDate = $filter("date")($ctrl.event.EventDate, "MM/dd/yyyy");
            $ctrl.eventCopy = ng.copy($ctrl.event);
            $ctrl.eventGroupCopy = ng.copy($ctrl.eventGroup);

            calcStats();
        }
    }
})(window.app, window.angular); //jshint ignore:line